// extracted by mini-css-extract-plugin
export var deleteModal = "_i3-0";